import type { ApplicationConfig } from './ApplicationConfig';
import { devConfig } from './ApplicationConfig.dev';
import { stagingConfig } from './ApplicationConfig.staging';
import { prodConfig } from './ApplicationConfig.prod';
import { localConfig } from './ApplicationConfig.local';

export class ConfigReader {
  private static instance: ConfigReader;
  private config: ApplicationConfig;

  private constructor() {
    this.config = this.detectEnvironment();
  }

  public static getInstance(): ConfigReader {
    if (!ConfigReader.instance) {
      ConfigReader.instance = new ConfigReader();
    }
    return ConfigReader.instance;
  }

  public getConfig(): ApplicationConfig {
    return this.config;
  }

  private detectEnvironment(): ApplicationConfig {
    const hostname = window.location.hostname;

    if (hostname === 'admin.skin-seoul.work') {
      return prodConfig;
    } else if (hostname === 'staging.admin.skin-seoul.work') {
      return stagingConfig;
    } else if (hostname === 'dev.admin.skin-seoul.work') {
      return devConfig;
    } else {
      // Default to dev for localhost and any other domains
      return localConfig;
    }
  }
}
